






























































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import RedRouteStepQuestions from "@/components/RedRouteStepQuestions.vue";
import RedRouteStepFileUpload from "@/components/RedRouteStepFileUpload.vue";
import { AppConstants, Models, apiService, Interfaces } from "@/core/Export";
import { date } from "quasar";
import store from "@/store";
@Component({
  components: { RedRouteStepQuestions, RedRouteStepFileUpload },
})
export default class RedRouteWizardPage extends Vue {
  questionCodes = AppConstants.QuestionCodes;
  currentQuestion: any;
  currentQuestionCodeKey: string = "";
  saveTRequestModel: any = {};
  filesFormData: FormData = new FormData();
  isContinueRequest: boolean = false;
  showSignTermsSection: boolean = false;
  tooltipWiard: Array<boolean> = [];
  componentKey = 0;

  constructor() {
    super();
  }

  created() {
    this.isContinueRequest = Boolean(this.$route.query.isContinue);
    this.onSetFirstQuestion();
  }

  toggleTooltip(index) {
    this.tooltipWiard[index] = !this.tooltipWiard[index];
    this.componentKey += 1;
    //this.$forceUpdate()
  }

  onSetFirstQuestion() {
    if (this.isContinueRequest) {
      this.onSetQuestionsAnswersFromModel();
    }

    let firstQuestion = this.tRequestModel.questionary.find((s) => s.isFirst);

    if (firstQuestion) {
      this.currentQuestion = firstQuestion;
      this.currentQuestion.previousStep = AppConstants.QuestionCodes.FromStep;
      this.currentQuestionCodeKey = this.currentQuestion.code;
      if (!firstQuestion.displayToClient) {
        this.onNextStep();
      }
    }

    let pensioner = this.tRequestModel.questionary.find(
      (s) => s.code == AppConstants.QuestionCodes.Pensioner
    );
    if (pensioner) {
      pensioner.answer = this.tRequestModel.requestDto.isPensioner;
    }
  }

  onSaveAndExit(isDraft) {
    let mobile = this.$q.screen.xs || this.$q.screen.sm;
    if (mobile && isDraft) {
      confirm(
        "לתשומת ליבך, לחיצה על כפתור זה תשמור את הפרטים שמולאו עד כה. תוכל לחזור במועד מאוחר יותר להמשך התהליך"
      );
    }
    this.onSaveAndExitAction(isDraft);
  }

  onSaveAndExitAction(isDraft) {
    if (!isDraft && this.hasFormDataFiles()) {
      this.appEnv.showErrorDialog([{ message: "חובה להעלות את כל הקבצים" }]);
      return;
    } else {
      this.checkIfFileIsAcceptable()
        .then((res) => {
          if (res && !res.isSuccess) {
            this.appEnv.isBusy = false;
            this.appEnv.showErrorDialog(res.msgs.errors);
            return;
          } else {
            this.appEnv.isBusy = false;
            if (
              this.tRequestModel.requestDto.requestStatusCode &&
              this.tRequestModel.requestDto.requestStatusCode ==
                AppConstants.RequestStatus.IncompleteDetails &&
              !isDraft
            ) {
              this.onSaveRequest(isDraft);
            } else if (!isDraft) {
              this.showSignTermsSection = true;
            } else {
              this.onSaveRequest(isDraft);
            }
          }
        })
        .catch((err) => {
          this.appEnv.isBusy = false;
        });
    }
  }

  onIsTermsApproved(value) {
    if (value) {
      this.onSaveRequest(false);
    }
  }

  checkIfFileIsAcceptable(): Promise<any> {
    let filesToCheck = new Array<any>();
    if (!this.filesFormData || this.filesFormData.entries.length == 0)
      return new Promise((res) => {
        res({ isSuccess: true });
      });
    this.filesFormData.forEach((item) => {
      var file = item as File;
      filesToCheck.push((({ type, name }) => ({ type, name }))(file));
    });
    this.appEnv.isBusy = true;
    return apiService
      .post("File/CheckIfFileIsAcceptable", filesToCheck)
      .then((res) => {
        if (res && !res.isSuccess) {
          this.appEnv.showErrorDialog(res.msgs.errors);
        }
        this.appEnv.isBusy = false;
        return new Promise((resolve) => {
          resolve(res);
        });
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
        return new Promise((resolve) => {
          resolve(err);
        });
      });
  }

  onSaveRequest(isDraft) {
    this.checkIfFileIsAcceptable()
      .then((res) => {
        if (res && res.isSuccess) {
          this.onPrepareRequestForSave(isDraft);
          apiService
            .post("Request/UpdateRequest", this.saveTRequestModel)
            .then((res) => {
              let response = res as Interfaces.ICallResult;
              if (response && response.isSuccess) {
                if (
                  this.currentQuestion.code ==
                  AppConstants.QuestionCodes.UploadFileFinalStep
                ) {
                  this.onUploadRequestFiles(isDraft);
                } else {
                  this.navigateToRequestFinishPage(
                    this.saveTRequestModel.requestNo,
                    this.saveTRequestModel.requestFormObj.year,
                    isDraft.toString()
                  );
                }
              } else {
                this.appEnv.showErrorDialog(response.msgs.errors);
              }
              this.appEnv.isBusy = false;
            })
            .catch((err) => {
              this.appEnv.isBusy = false;
            });
        } else {
          this.appEnv.showErrorDialog(res.msgs.errors);
          this.appEnv.isBusy = false;
        }
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  onPrepareRequestForSave(isDraft: boolean) {
    this.saveTRequestModel = JSON.parse(
      JSON.stringify(this.tRequestModel.requestDto)
    );
    this.saveTRequestModel.isDraft = isDraft;

    let dob = this.appEnv.toUTC(this.saveTRequestModel.requestFormObj.dob);
    let residentFromDate = this.appEnv.toUTC(
      this.saveTRequestModel.requestFormObj.residentFromDate
    );
    let fillFormDate = this.appEnv.toUTC(
      this.saveTRequestModel.requestFormObj.fillFormDate
    );

    if (this.saveTRequestModel.requestFormObj.partnerDob) {
      let partnerDob = this.appEnv.toUTC(
        this.saveTRequestModel.requestFormObj.partnerDob
      );
      if (partnerDob) {
        this.saveTRequestModel.requestFormObj.partnerDob = partnerDob;
      }
    }

    if (dob) {
      this.saveTRequestModel.requestFormObj.dob = dob;
    }

    if (residentFromDate) {
      this.saveTRequestModel.requestFormObj.residentFromDate = residentFromDate;
    }

    if (fillFormDate) {
      this.saveTRequestModel.requestFormObj.fillFormDate = fillFormDate;
    }

    this.saveTRequestModel.requestFormObj.children.forEach((child) => {
      let childDob = this.appEnv.toUTC(child.dob);
      if (childDob) {
        child.dob = childDob;
      }
    });
  }

  onUploadRequestFiles(isDraft: boolean) {
    apiService
      .uploadFiles(this.tRequestModel.requestDto.id, this.filesFormData)
      .then((res) => {
        let response = res as Interfaces.ICallResult;
        if (response && response.result["isSuccess"]) {
          this.navigateToRequestFinishPage(
            this.saveTRequestModel.requestNo,
            this.saveTRequestModel.requestFormObj.year,
            isDraft.toString()
          );
        } else {
          this.appEnv.showErrorDialog(response.msgs.errors);
        }
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  navigateToRequestFinishPage(requestNo, year, isDraft) {
    this.appEnv.canViewRequestFinishApprovePage = true;
    this.$router.push({
      name: AppConstants.Routes.Finish,
      params: { requestNo: requestNo, year: year },
      query: { isDraft: isDraft },
    });
  }

  onPreviousStep() {
    if (
      this.currentQuestion.previousStep == AppConstants.QuestionCodes.FromStep
    ) {
      this.$router.back();
    } else {
      let previousQuestion = this.tRequestModel.questionary.find(
        (s) => s.code == this.currentQuestion.previousStep
      );
      this.currentQuestion = previousQuestion;
      if (!previousQuestion.displayToClient) {
        this.onPreviousStep();
      }
      this.currentQuestionCodeKey = this.currentQuestion.code;
    }
  }

  onNextStep() {
    let nextQuestion = null;
    if (this.currentQuestion.isBoolQuestion) {
      if (this.currentQuestion.answer) {
        nextQuestion = this.tRequestModel.questionary.find(
          (s) => s.id == this.currentQuestion.nextTrueId
        );
      } else {
        nextQuestion = this.tRequestModel.questionary.find(
          (s) => s.id == this.currentQuestion.nextFalseId
        );
      }
    } else {
      let optionAnswer = this.currentQuestion.answerList.find(
        (s) => s.id == this.currentQuestion.answer
      );
      if (optionAnswer) {
        if (optionAnswer.isTrue) {
          nextQuestion = this.tRequestModel.questionary.find(
            (s) => s.id == this.currentQuestion.nextTrueId
          );
        } else {
          nextQuestion = this.tRequestModel.questionary.find(
            (s) => s.id == this.currentQuestion.nextFalseId
          );
        }
      }
    }

    if (nextQuestion == null) return;
    this.currentQuestion = nextQuestion;
    this.currentQuestion.previousStep = this.currentQuestionCodeKey;
    this.currentQuestionCodeKey = this.currentQuestion.code;
    if (!nextQuestion.displayToClient) {
      this.onNextStep();
    }
  }

  onSetQuestionsAnswersFromModel() {
    this.tRequestModel.questionary.forEach((question) => {
      switch (question.code) {
        case AppConstants.QuestionCodes.RentQuestion:
        case AppConstants.QuestionCodes.RentQuestion2:
          return (question.answer = this.tRequestModel.requestDto.isPayRent);
        case AppConstants.QuestionCodes.WorkPlaceAreaQuestion:
          return (question.answer =
            this.tRequestModel.requestDto.workplaceAreaId);
          break;
        case AppConstants.QuestionCodes.WorkPlaceAreaPartnerQuestion:
          return (question.answer =
            this.tRequestModel.requestDto.partnerWorkPlaceAreaId);
          break;
        case AppConstants.QuestionCodes.SecurityForceQuestion:
          return (question.answer =
            this.tRequestModel.requestDto.isSecurityForces);
          break;
        case AppConstants.QuestionCodes.StudentQuestion:
          return (question.answer = this.tRequestModel.requestDto.isStudent);
          break;
        case AppConstants.QuestionCodes.SelfEmployed:
          return (question.answer =
            this.tRequestModel.requestDto.isSelfEmployed);
          break;
        case AppConstants.QuestionCodes.EducationApprovement:
          return (question.answer =
            this.tRequestModel.requestDto.EducationApprovement);
          break;
        default:
          break;
      }
    });
  }

  onSetQuestionAnswer() {
    switch (this.currentQuestion.code) {
      case AppConstants.QuestionCodes.RentQuestion:
      case AppConstants.QuestionCodes.RentQuestion2:
        this.tRequestModel.requestDto.isPayRent = this.currentQuestion.answer;
        break;
      case AppConstants.QuestionCodes.WorkPlaceAreaQuestion:
        this.tRequestModel.requestDto.workplaceAreaId =
          this.currentQuestion.answer;
        break;
      case AppConstants.QuestionCodes.WorkPlaceAreaPartnerQuestion:
        this.tRequestModel.requestDto.partnerWorkPlaceAreaId =
          this.currentQuestion.answer;
        break;
      case AppConstants.QuestionCodes.StudentQuestion:
        this.tRequestModel.requestDto.isStudent = this.currentQuestion.answer;
        break;
      case AppConstants.QuestionCodes.SecurityForceQuestion:
        this.tRequestModel.requestDto.isSecurityForces =
          this.currentQuestion.answer;
        break;
      case AppConstants.QuestionCodes.SelfEmployed:
        this.tRequestModel.requestDto.isSelfEmployed =
          this.currentQuestion.answer;
        break;
      case AppConstants.QuestionCodes.EducationApprovement:
        this.tRequestModel.requestDto.re = this.currentQuestion.answer;
        break;
      default:
        break;
    }
  }

  hasFormDataFiles() {
    let hasFilesError = false;
    this.requiredFileList.forEach((file) => {
      let hasFile = this.filesFormData.has(file.code);
      if (!hasFile) {
        hasFilesError = true;
      }
    });
    return hasFilesError;
  }

  get fileToUploadParams() {
    var partialAdditionalCondiotions = this.tRequestModel.questionary.find(
      (s) => s.code == "PartialAdditionalConsition"
    );
    if (partialAdditionalCondiotions)
      var partialAdditionalCondiotionsAns = partialAdditionalCondiotions.answer;
    var fullAdditionalCondiotions = this.tRequestModel.questionary.find(
      (s) => s.code == "FullAdditionalCondition"
    );
    if (fullAdditionalCondiotions)
      var fullAdditionalCondiotionsAns = fullAdditionalCondiotions.answer;

    return {
      isPayRent: this.tRequestModel.requestDto.isPayRent,
      workPlaceAreaId: this.tRequestModel.requestDto.workplaceAreaId,
      partnerWorkPlaceAreaId:
        this.tRequestModel.requestDto.partnerWorkPlaceAreaId,
      fullAdditionalCondiotions: fullAdditionalCondiotionsAns,
      partialAdditionalCondiotions: partialAdditionalCondiotionsAns,
      isSecurityForces: this.tRequestModel.requestDto.isSecurityForces,
      isStudent: this.tRequestModel.requestDto.isStudent,
      isSelfEmployed: this.tRequestModel.requestDto.isSelfEmployed,
      personYearId: this.tRequestModel.requestDto.personYearId,
      isPensioner: this.tRequestModel.requestDto.isPensioner,
    };
  }

  extractDate(value) {
    if (value) return date.extractDate(value, "DD/MM/YYYY");
  }

  get titleLabel() {
    if (
      this.currentQuestionCodeKey !=
      AppConstants.QuestionCodes.UploadFileFinalStep
    ) {
      return "";
    } else if (this.showSignTermsSection) {
      return "שלום";
    } else {
      return "העלאת קבצים";
    }
  }

  get propgressBarValue() {
    if (
      this.currentQuestionCodeKey !=
      AppConstants.QuestionCodes.UploadFileFinalStep
    ) {
      return 0.5;
    } else {
      return 1;
    }
  }

  get requiredFileList() {
    let arr = this.fileList.slice(0);
    if (!this.uploadedFilesList) return this.fileList;
    this.fileList.forEach((file) => {
      let uploadedFile = this.uploadedFilesList.findIndex(
        (s) => s.code === file.code
      );
      if (uploadedFile > -1) {
        var index = arr.findIndex((s) => s.code == file.code);
        arr.splice(index, 1);
      }
    });
    return arr;
  }

  get refferResidentToDep() {
    var val;
    if (this.systemData && this.systemData["systemSettings"]) {
      val =  this.systemData["systemSettings"].refferResidentToDep;
    } 
    if(!val) val = "למחלקת מרכז שירות לתושב";
    return val;
  }

  get systemData() {
    return store.getters.systemData;
  }

  get uploadedFilesList() {
    return store.getters.tRequestModel.filesList;
  }

  get fileList() {
    return store.getters.fileList;
  }

  get tRequestModel() {
    return store.getters.tRequestModel;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
